export const ROUTE_PATHS = {
  HOME: '/',
  MENU: '/menu',
  ABOUT: '/a-propos',
  INSTAGRAM: '/instagram',
  CONTACT: '/contact',
} as const;

export interface MenuItem {
  id: string;
  name: string;
  description?: string;
  price: number;
  image?: string;
  category: string;
  isChildMenu?: boolean;
}

export interface MenuCategory {
  id: string;
  title: string;
  items: MenuItem[];
}

export const RESTAURANT_CONSTANTS = {
  NAME: "Service-Pépinière Blessing",
  OWNER: "Mabaga Karine",
  ADDRESS: "64 rue Clisson, 75013 Paris, France",
  EMAIL: "mabagakarine@gmail.com",
  WHATSAPP_LINK: "https://wa.me/33758747528",
  INSTAGRAM_LINK: "https://www.instagram.com/pepiniere_blessing?igsh=a3oyZm5oa2FpMW1o&utm_source=qr",
  HOURS: "Ouvert tous les jours de 11h30 à 22h (23h max)",
  CUISINE_TYPES: "Africaine & Européenne",
} as const;